import { Close, FilterList } from '@mui/icons-material'
import {
  Box,
  FormControl,
  FormControlLabel, Grid,
  IconButton,
  Popover,
  Radio,
  RadioGroup,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import React, {  useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AmericanStatesActions, AmericanStatesSelector } from '../../../store/AmericanStates'

import {
  WaterSystemsActions,
  WaterSystemsSelector,
  WaterSystemType,
} from '../../../store/waterSystems'
import { AddressSearchForm } from '../../AddressSearchForm'
import { StatesSearch } from '../../StatesDropdown'
import MarkerDetailsPopup from './MarkerDetailsPopup'

const MobileForm = () => {
  const theme = useTheme()
  const selectedState = useSelector(AmericanStatesSelector.getSelectedState)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [waterSource, setWaterSource] = useState('public')
  const dispatch = useDispatch()
  //const popupDetail = useSelector(MapSelector.getPopUpDetail)
  const waterSystemType = useSelector(WaterSystemsSelector.getSelectedWaterSystemType)
  const handleFilterClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleWaterSourceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setWaterSource(event.target.value)
    dispatch(WaterSystemsActions.setSelectedSystemType(event.target.value as WaterSystemType))
    handleClose()
  }

  const open = Boolean(anchorEl)
  const id = open ? 'states-popover' : undefined

  return (
    <Box
      sx={{
        position: 'absolute',
        display: 'flex',
        p: 2,
        zIndex: 2,
        width: '100%',
        gap: 1,
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      <Grid container flexDirection="column" gap={2} width="100%">
        <Grid container flexDirection="row" gap={1} justifyContent="center" alignItems="center" flexGrow={1} flexWrap="nowrap" >
          <AddressSearchForm />
          {/* <ZipCodeForm /> */}
          <Stack
            direction={'row'}
            alignItems={'center'}
            sx={{
              background: 'white',
              borderRadius: '8px',
              border: '1px solid #D0D5DD',
              px: selectedState.state ? 1 : 0,
            }}
          >
            {selectedState.state && (
              <Stack direction={'row'} alignItems={'center'}>
                <Typography fontSize={'0.825rem'}>{selectedState?.state}</Typography>
                <IconButton
                  sx={{
                    p: '7px',
                  }}
                  onClick={() => {
                    dispatch(AmericanStatesActions.setSelectedState({}))
                  }}
                >
                  <Close />
                </IconButton>
              </Stack>
            )}
            <IconButton
              sx={{
                p: '7px',
              }}
              onClick={handleFilterClick}
            >
              <FilterList />
            </IconButton>
          </Stack>
        </Grid>
        <Grid container >

          <MarkerDetailsPopup
            staticPosition
            showExpand
            waterSystemType={waterSystemType}
          />
        </Grid>
      </Grid>


      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{
          '& .MuiPaper-root': {
            borderRadius: '8px',
            boxShadow: theme.shadows[2],
            width: 250,
            maxHeight: '60vh',
            overflowY: 'hidden',
            mt: 2,
          },
        }}
      >
        <Stack sx={{ p: 2, gap: 2 }}>
          <FormControl
            component="fieldset"
            sx={{
              p: 1,
              bgcolor: 'grey.100',
              borderRadius: '8px',
            }}
          >
            <RadioGroup
              value={waterSource}
              onChange={handleWaterSourceChange}
              aria-labelledby="water-source-group"
              sx={{}}
            >
              <FormControlLabel
                value={WaterSystemType.PUBLIC}
                slotProps={{
                  typography:{
                    variant: 'body-small',
                  }
                }}
                control={ <Radio /> }
                label='Public Water System'
              />
              <FormControlLabel
                value={WaterSystemType.WELL}
                disabled
                slotProps={{
                  typography:{
                    variant: 'body-small',
                  }
                }}
                control={<Radio/>}
                label='Well Water System (coming soon)'
              />
            </RadioGroup>
          </FormControl>
          <StatesSearch handleClose={handleClose} />
        </Stack>
      </Popover>
    </Box>
  )
}

export default MobileForm
